import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad883d86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "loading-cover"
}
const _hoisted_3 = { class: "device-info van-hairline--bottom" }
const _hoisted_4 = { class: "icon-wrap verify-info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "9",
    cy: "9",
    r: "8",
    fill: "#00C378"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.60083 9.76858L6.39408 8.89744C6.27517 8.81159 6.21571 8.76866 6.15503 8.74536C6.01724 8.69243 5.86309 8.70309 5.7339 8.77449C5.67701 8.80593 5.62403 8.85663 5.51806 8.95803C5.38788 9.0826 5.32279 9.14489 5.28604 9.2111C5.20225 9.36204 5.20225 9.54553 5.28604 9.69646C5.32279 9.76267 5.38788 9.82496 5.51806 9.94953L7.19539 11.5546C7.45568 11.8037 7.86594 11.8037 8.12623 11.5546L12.4995 7.36969C12.6134 7.26075 12.6703 7.20627 12.7045 7.14969C12.8009 6.99052 12.8009 6.791 12.7045 6.63182C12.6703 6.57524 12.6134 6.52077 12.4995 6.41182C12.4002 6.31674 12.3505 6.26921 12.2986 6.23919C12.1533 6.15503 11.9754 6.14945 11.8251 6.22433C11.7715 6.25104 11.7189 6.29537 11.6138 6.38403L7.60083 9.76858Z",
    fill: "white"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "验机成功", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-line" }, [
  /*#__PURE__*/_createElementVNode("div", null, "验机架次")
], -1))
const _hoisted_8 = { class: "tips-line" }
const _hoisted_9 = { class: "list" }
const _hoisted_10 = {
  key: 0,
  class: "empty-item"
}
const _hoisted_11 = { class: "confirm-agreement" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-content" }, "本人已确认以上验机内容属实", -1))

import { sleep } from '@/utils/index'
import { useRoute } from 'vue-router'
import { Checkbox, Loading } from 'vant'
import { showConfirmModal } from '@/utils/tools'
import { getDeviceFlyCheckInfo } from '@/apis/insurance'
import { commonErrorHandle } from '@/utils/error-handle'
import { ref, withDefaults, Ref, watch } from 'vue'
import { TestDeviceResult, TestDeviceFlyListResult } from '@/types/insurance'
import IconSvgWrap from '@/components/icon/IconSvgWrap.vue'
import CommonPopupWrap from '@/components/popup/common-wrap.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'electronic-components-record',
  props: {
    show: { type: Boolean, default: false },
    data: { default: () => null }
  },
  emits: ['update:show', 'next'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, data: null | TestDeviceResult };


const $route = useRoute()

const agree = ref(false)
const loading = ref(false)
const detailInfo: Ref<TestDeviceFlyListResult | null> = ref(null)
const recordList: Ref<string[]> = ref([])
const vantPopupProps = {
  beforeClose: async () => {
    if ($route?.name !== 'insurance-jijia-device-select') {
      return true
    }
    if (!props.show) {
      return true
    }
    try {
      await showConfirmModal({
        title: '提示',
        message: `关闭后需要重新进行验机才能投保，确认关闭当前窗口？`,
        confirmButtonText: '知道了',
        className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-warning-class',
      })
      return true
    } catch (error) {
      return false
    }
  },
}
watch(
  () => props.show,
  () => {
    console.log('props.show', props.show)
    if (props.show) {
      initPageData()
    } else {
      // 关闭的时候清空已同意
      agree.value = false
    }
  }
)
function updateShow(value: boolean) {
  emits('update:show', value)
}
function nextHandle() {
  emits('next')
}
async function initPageData() {
  if (!props?.data?.id) {
    return
  }
  loading.value = true
  try {
    const data = await getDeviceFlyCheckInfo(props?.data?.id)
    detailInfo.value = data
    recordList.value = data.sn_list.map((item) => item.sn)
  } catch (error) {
    commonErrorHandle(error)
  }
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonPopupWrap, {
    show: props.show,
    teleport: "body",
    title: "架次电子件记录",
    "onUpdate:show": updateShow,
    "header-style": {
      backgroundColor: 'white',
    },
    "vant-popup-props": vantPopupProps
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Loading))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(IconSvgWrap, { size: 48 }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(detailInfo.value?.log_name) + "（" + _toDisplayString(detailInfo.value?.log_long) + "）", 1)
        ]),
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recordList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "van-hairline--bottom"
            }, _toDisplayString(item), 1))
          }), 128)),
          (recordList.value.length === 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, "暂无数据"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(Checkbox), {
            modelValue: agree.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((agree).value = $event)),
            shape: "square",
            "icon-size": 16,
            "checked-color": "#00C378"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(CommonFooterNextButton, {
          btnStyle: {
          height: '40px',
        },
          disabled: !agree.value,
          onClick: nextHandle
        }, null, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})